import type {
  CreateRecurringRequest,
  RecurringTemplateDto,
  UpdateRecurringRequest,
} from '@ledokol/contracts'
import { api } from './client'

export async function fetchRecurring(projectId: string): Promise<RecurringTemplateDto[]> {
  const r = await api.get<RecurringTemplateDto[]>(`/projects/${projectId}/recurring`)
  return r.data
}

export async function createRecurring(
  projectId: string,
  body: CreateRecurringRequest,
): Promise<RecurringTemplateDto> {
  const r = await api.post<RecurringTemplateDto>(`/projects/${projectId}/recurring`, body)
  return r.data
}

export async function updateRecurring(
  id: string,
  body: UpdateRecurringRequest,
): Promise<RecurringTemplateDto> {
  const r = await api.patch<RecurringTemplateDto>(`/recurring/${id}`, body)
  return r.data
}

export async function deleteRecurring(id: string): Promise<void> {
  await api.delete(`/recurring/${id}`)
}
